import HttpResponse from "../../../../../../utils/http/http.response";

type OrderTransportingOrderForwardingDeleteSuccessResponse =
  HttpResponse<string>;

export enum OrderTransportingOrderForwardingDeleteNotAcceptableResponseErrorType {
  ABANDONED_ORDER = "ABANDONED_ORDER",
  DRIVER_ASSIGNED = "DRIVER_ASSIGNED",
}

export type OrderTransportingOrderForwardingDeleteNotAcceptableResponseAbandonedOrder =
  {
    errorType: OrderTransportingOrderForwardingDeleteNotAcceptableResponseErrorType.ABANDONED_ORDER;
  };

export type OrderTransportingOrderForwardingDeleteNotAcceptableResponseDriverAssigned =
  {
    errorType: OrderTransportingOrderForwardingDeleteNotAcceptableResponseErrorType.DRIVER_ASSIGNED;
  };

type OrderTransportingOrderForwardingDeleteNotAcceptableResponseError =
  | OrderTransportingOrderForwardingDeleteNotAcceptableResponseAbandonedOrder
  | OrderTransportingOrderForwardingDeleteNotAcceptableResponseDriverAssigned;

export type OrderTransportingOrderForwardingDeleteNotAcceptableResponse =
  HttpResponse<OrderTransportingOrderForwardingDeleteNotAcceptableResponseError>;

type OrderTransportingOrderForwardingDeleteResponse =
  | OrderTransportingOrderForwardingDeleteSuccessResponse
  | OrderTransportingOrderForwardingDeleteNotAcceptableResponse;

export default OrderTransportingOrderForwardingDeleteResponse;
